import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import {
  DialogContent,
  Dialog,
  Slide,
  IconButton,
  Button,
  Typography,
  DialogTitle,
} from "@material-ui/core";
import { ReactComponent as CheckSVG } from "../../../assets/vote-check.svg";

import { ReactComponent as ThumbUpSvg } from "../../../assets/thumb-up.svg";
import { ReactComponent as ThumbDownSvg } from "../../../assets/thumb-down-red.svg";

import CloseIcon from "@material-ui/icons/Close";

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const styles = (theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    background: theme?.colors?.stake?.background,
    width: "100%",
    minHeight: "100%",
    overflow: "auto",
    position: "relative",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "25px 45px",

    borderRadius: "30px",
  },
  modalRoot: {
    maxWidth: "640px",
    [theme.breakpoints.up("md")]: {
      borderRadius: "30px",
    },
  },
  paper: {
    background: theme?.colors?.swap?.background,
    borderRadius: "30px",
    boxShadow:
      "0px 10px 60px " + theme?.colors?.containerShadow + " !important",
  },
  closeButton: {
    position: "absolute",
    right: "32px",
  },
  screenMask: {
    backgroundColor: "rgba(0, 0, 0, 0.3)",
  },
  modalContainer: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  walletButton: {
    borderRadius: "20px",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,.05)",
    backgroundColor: theme?.colors?.wallet?.buttonBackground,
    color: theme?.colors?.wallet?.buttonTextSecondary,
    textTransform: "capitalize",
    height: "40px",
    padding: "8px 16px",
    "&:hover": {
      backgroundColor: theme?.colors?.wallet?.buttonBackgroundHover,
      color: theme?.colors?.wallet?.buttonTextSecondary,
    },
    "&:disabled": {
      opacity: "0.7",
      color: theme?.colors?.wallet?.buttonTextSecondary,
      cursor: "not-allowed",
    },

    width: "100%",

    [theme.breakpoints.up("sm")]: {
      minWidth: "150px",
    },
  },
  outlineButton: {
    borderRadius: "20px",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,.05)",
    backgroundColor: "transparent",
    border: "solid 2px" + theme?.colors.poolCard?.statusBarFilled["RED"],
    textTransform: "capitalize",
    height: "40px",
    color: theme?.colors.poolCard?.statusBarFilled["RED"],
    padding: "8px 16px",
    "&:hover": {
      border: "solid 2px #e45656",
      color: "#e45656",
    },
    fontFamily: "Poppins",
    letterSpace: "0px",
    whiteSpace: "nowrap",

    width: "100%",

    [theme.breakpoints.up("sm")]: {
      minWidth: "150px",
    },
  },
  buttonLabel: {
    fontWeight: "bold",
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
  },
  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
    width: "100%",
  },

  modalHeadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    padding: "8px 24px 0px",
  },

  modalHeadingLogoName: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    fontSize: "25px",
    color: theme?.colors?.presale?.cardTitle,
    fontWeight: 600,
    margin: 0,
  },
  modalCloseIcon: {
    width: "28px",
    height: "28px",
    position: "absolute",
    top: "25px",
    right: "25px",
    color: theme?.colors?.presale?.cardTitle,
    cursor: "pointer",
    "&:hover": {
      opacity: 0.8,
    },
  },

  votingWarning: {
    color: theme?.colors?.home?.text,

    fontSize: "20px",
    fontWeight: "normal",
    lineHeight: "18px",
    marginBottom: "30px",
    textAlign: "center",
  },
  voteDescription: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginBottom: "30px",
  },
  voteTipText: {
    color: theme?.colors?.presale?.commentText,
    fontSize: "17px",
    fontWeight: "normal",
    lineHeight: "25px",
  },
  actionContainer: {
    width: "100%",
    gap: "8px",
    alignItems: "center",

    display: "grid",
    gridTemplateColumns: "1fr 1fr",

    [theme.breakpoints.up("sm")]: {
      gap: "20px",
    },
  },
  closeIcon: {
    color: theme?.colors?.header?.closeButton,
    width: "32px",
    height: "32px",
  },
  voteUpIcon: {
    width: "20px",
    height: "15px",
    marginRight: "8px",

    [theme.breakpoints.down("sm")]: {
      width: "15px",
      height: "12px",
    },

    "& > path": {
      fill: theme?.colors?.presale?.cardTitleTertiary + "!important",
    },
  },
  voteDownIcon: {
    width: "20px",
    height: "15px",
    marginRight: "8px",

    [theme.breakpoints.down("sm")]: {
      width: "15px",
      height: "12px",
    },

    "& > path": {
      fill: theme?.colors.poolCard?.statusBarFilled["RED"] + "!important",
    },
  },
});

const VoteModal = ({ classes, closeModal, modalOpen, salesTitle, onVote }) => {
  return (
    <Dialog
      open={modalOpen}
      onClose={(e) => {
        e.stopPropagation();
        closeModal();
      }}
      fullWidth={true}
      maxWidth={"sm"}
      TransitionComponent={Transition}
      classes={{ paper: classes.paper, paperWidthSm: classes.modalRoot }}
    >
      <DialogTitle disableTypography className={classes.modalHeader}>
        <div className={classes.modalHeadingContainer}>
          <p className={classes.modalHeadingLogoName}>Confirmation</p>
        </div>
        <IconButton
          aria-label="close"
          className={classes.modalCloseIcon}
          onClick={(e) => {
            e.stopPropagation();
            closeModal();
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent classes={{ root: classes.root }}>
        <div className={classes.modalContainer}>
          <Typography variant="h5" className={classes.votingWarning}>
            You are about to vote on <b>{salesTitle}</b>. This action cannot be
            undone. Some of the things to lookout for:
          </Typography>
          <div className={classes.voteDescription}>
            <Typography variant="h3" className={classes.voteTipText}>
              1. This project has purpose and potential <CheckSVG />
            </Typography>
            <Typography variant="h3" className={classes.voteTipText}>
              2. Github has active development activity <CheckSVG />
            </Typography>
            <Typography variant="h3" className={classes.voteTipText}>
              3. Smart Contract audit results are positive <CheckSVG />
            </Typography>
            <Typography variant="h3" className={classes.voteTipText}>
              4. Devs are not anon or I am comfortable with them <CheckSVG />
            </Typography>
            <Typography variant="h3" className={classes.voteTipText}>
              5. Tokenomics are generally sound <CheckSVG />
            </Typography>
            <Typography variant="h3" className={classes.voteTipText}>
              6. This does not look like a rug or scam <CheckSVG />
            </Typography>
          </div>
          <div className={classes.actionContainer}>
            <Button
              classes={{
                root: classes.walletButton,
                label: classes.buttonLabel,
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (onVote) {
                  onVote(true);
                }
                closeModal();
              }}
            >
              <ThumbUpSvg className={classes.voteUpIcon} />
              YES
            </Button>
            <Button
              classes={{
                root: classes.outlineButton,
                label: classes.buttonLabel,
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (onVote) {
                  onVote(false);
                }
                closeModal();
              }}
            >
              <ThumbDownSvg className={classes.voteDownIcon} />
              NO
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
export default withRouter(withStyles(styles)(VoteModal));
